import { styled } from "@linaria/react";
import { StaticImage } from "gatsby-plugin-image";
import React from "react";

const Banner = styled.div`
  width: 100%;
  padding: 2.5rem 5rem;
  min-height: 190px;
  display: flex;
  align-items: center;
  justify-content: center;
  background:
    radial-gradient(
      343.4% 80.58% at 101.6% 114.66%,
      rgba(75, 235, 255, 0.2) 0%,
      rgba(0, 0, 0, 0.2) 50%
    ),
    radial-gradient(
      100.9% 79.65% at 21.35% -14.14%,
      rgba(75, 235, 255, 0.2) 0%,
      rgba(0, 0, 0, 0.2) 100%
    ),
    var(--primary-bg);
  gap: 5rem;
  @media (max-width: 1024px) {
    gap: 0;
  }
`;

const BannerTitle = styled.h3`
  color: var(--white);
  font-weight: 600;
  font-size: 44px;
  span {
    color: var(--primary);
  }
  @media (max-width: 1024px) {
    font-size: 32px;
  }
  @media (max-width: 768px) {
    font-size: 28px;
  }
  @media (max-width: 425px) {
    font-size: 24px;
  }
`;

const AiBanner = () => {
  return (
    <Banner>
      <BannerTitle>
        Artificial Intelligence <span>Winner</span>
      </BannerTitle>
      <StaticImage
        src="./assets/ai-banner-image.png"
        loading="lazy"
        height={188}
        style={{ minWidth: 188 }}
      />
    </Banner>
  );
};

export default AiBanner;
